import { useState } from 'react';
import { Alert } from 'react-bootstrap';
import { window } from '../../../globals';
import { RouterLink } from '../Link';
import './AnnouncementBanner.less';

export const SHOW_ANNOUNCEMENT_AFTER_DATE = '2024-08-28';
export const HIDE_ANNOUNCEMENT_AFTER_DATE = '2024-09-04';

/**
 * AnnouncementBanner
 *
 * This component is used to display a general announcement on the FOSSA site.
 * For now, the announcement message is hard-coded and gated behind a feature flag.
 * In the future, we can explore hooking into the API to get the message and possibly re-using the BannerManager.
 */
const AnnouncementBanner = () => {
  // declare show state
  const [isShowing, setShow] = useState(true);
  const announcementStartDate = new Date(SHOW_ANNOUNCEMENT_AFTER_DATE);

  const today = new Date();
  const isCurrentDateAfterHideDate = today > new Date(HIDE_ANNOUNCEMENT_AFTER_DATE);
  const isCurrentDateBeforeAnnouncementDate = today < announcementStartDate;
  const shouldShowAlert =
    isShowing && !window.on_prem && !isCurrentDateBeforeAnnouncementDate && !isCurrentDateAfterHideDate;

  if (!shouldShowAlert) {
    return null;
  }

  return (
    <Alert
      bsStyle="warning"
      bsClass="alert alert-general-announcement"
      onDismiss={() => {
        setShow(false);
      }}
    >
      <strong>Notice:</strong> FOSSA&apos;s IP list is changing on Tuesday, September 3rd.&nbsp;&nbsp;
      <RouterLink to="https://docs.fossa.com/docs/ip-space-whitelisting" openInNewTab>
        See the updated list here.
      </RouterLink>
    </Alert>
  );
};

export default AnnouncementBanner;
